export const DevicesGroupsActionTypes = {
  API_RESPONSE_SUCCESS: '@@devices-groups/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@devices-groups/API_RESPONSE_ERROR',

  GET_GROUP: '@@devices-groups/GET_GROUP',
  LIST_GROUPS: '@@devices-groups/LIST_GROUPS',
  ADD_GROUP: '@@devices-groups/ADD_GROUP',
  UPDATE_GROUP: '@@devices-groups/UPDATE_GROUP',
  DELETE_GROUP: '@@devices-groups/DELETE_GROUP',

  RESET: '@@devices-groups/RESET'
}
